import { ContactUsListConstants } from "../_constants/ContactUs.constants";

export default function ContactUsReducer(state = {}, action) {
  switch (action.type) {

    //get
    case ContactUsListConstants.GET_SUPPORT_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case ContactUsListConstants.GET_SUPPORT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        supportListReply: action?.user
      };
    case ContactUsListConstants.GET_SUPPORT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    //reply
    case ContactUsListConstants.GET_REPLYTICKETADMIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ContactUsListConstants.GET_REPLYTICKETADMIN_SUCCESS:
      return {
        ...state,

        loading: false,
        getReplyMsgTicketAdmin: action?.user,
      };
    case ContactUsListConstants.GET_REPLYTICKETADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case ContactUsListConstants.GET_MESSAGEONSUPPORT_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case ContactUsListConstants.GET_MESSAGEONSUPPORT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        supportListMessage: action?.user
      };
    case ContactUsListConstants.GET_MESSAGEONSUPPORT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state
  }
}
